/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
export function formatMetricValue(value, unit, locale) {
    if (typeof value !== 'number' || !isFinite(value)) return '—'
    switch (unit) {
        case 'percentage':
            return `${value.toFixed(1)}%`
        case 'minutes':
            return formatDurationSeconds(value * 60)
        case 'hours':
            return formatDurationSeconds(value * 3600)
        case 'ratio':
            return value.toFixed(2)
        case 'count':
        default:
            return value.toLocaleString(locale || 'fr-FR')
    }
}

function formatDurationSeconds(seconds) {
    if (!isFinite(seconds) || seconds < 0) return '—'
    const total = Math.round(seconds)
    const h = Math.floor(total / 3600)
    const m = Math.floor((total % 3600) / 60)
    if (h > 0) return `${h}h ${m}min`
    return `${m}min`
}

export function formatPeriodLabel(period, locale) {
    if (!period) return ''
    if (/^\d{4}-\d{2}$/.test(period)) {
        const [y, m] = period.split('-')
        const date = new Date(parseInt(y, 10), parseInt(m, 10) - 1, 1)
        return date.toLocaleDateString(locale || 'fr-FR', { month: 'short', year: 'numeric' })
    }
    if (/^\d{4}-\d{2}-\d{2}$/.test(period)) {
        const date = new Date(period)
        return date.toLocaleDateString(locale || 'fr-FR', { day: '2-digit', month: 'short' })
    }
    if (/^\d{4}-W\d{1,2}$/.test(period)) {
        return period.replace(/^\d{4}-W/, 'S')
    }
    return period
}

const PRIMARY_KEYS = ['xLabel', 'name', 'label', 'operator_name', 'user_name', 'status_name']

export function rowValue(row) {
    if (!row || typeof row !== 'object') return 0
    if (typeof row.value === 'number') return row.value
    if (typeof row.count === 'number') return row.count
    return 0
}

function nonEmpty(value) {
    return value !== undefined && value !== null && value !== ''
}

export function groupByRowLabel(row) {
    if (!row || typeof row !== 'object') return ''

    let primary = null
    for (const key of PRIMARY_KEYS) {
        if (nonEmpty(row[key])) {
            primary = String(row[key])
            break
        }
    }

    if (primary === null) {
        for (const key of Object.keys(row)) {
            const val = row[key]
            if (val && typeof val === 'object' && nonEmpty(val.name)) {
                primary = String(val.name)
                break
            }
        }
    }

    if (primary === null) {
        const key = Object.keys(row).find(
            (k) => k !== 'count' && k !== 'form_name' && !k.endsWith('_id')
        )
        primary = key ? String(row[key]) : ''
    }

    if (primary && row.form_name) {
        return `${primary} - ${row.form_name}`
    }
    return primary || ''
}

export const PALETTE = [
    '#0891b2', '#10b981', '#f59e0b', '#ef4444', '#6366f1',
    '#ec4899', '#14b8a6', '#f97316', '#8b5cf6', '#06b6d4',
    '#84cc16', '#dc2626'
]
